import { useTranslation } from 'react-i18next';

/**
 * Returns language-aware font families for headings and body text.
 * JP  → Noto Serif JP / Noto Sans JP
 * ZH  → Noto Serif SC / Noto Sans SC  (optimised for Simplified Chinese)
 * EN  → Cormorant Garamond / Noto Sans JP  (luxury Western serif for headings)
 */
export function useLangFont() {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const heading =
    lang === 'zh'
      ? "'Noto Serif SC', serif"
      : lang === 'en'
      ? "'Cormorant Garamond', Georgia, serif"
      : "'Noto Serif JP', serif";

  const body =
    lang === 'zh'
      ? "'Noto Sans SC', 'Noto Sans JP', sans-serif"
      : "'Noto Sans JP', sans-serif";

  return { heading, body };
}